const PageHeader = ({ title }) => (
  <header className="content-header">
    <div className="container-fluid">
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb mb-2">
          <li className="breadcrumb-item active fs-5" aria-current="page">
            {title}
          </li>
        </ol>
      </nav>
    </div>
  </header>
);

export default PageHeader;
